import React, { useEffect, useState } from "react";
import ConfettiIconColor from "../../../../../icons/ConfettiIconColor";
import SimpleHammerIcon from "../../../../../icons/SimpleHammerIcon";

interface BidderTagCardProps {
  latestBid: any;
  bidsEvent: any;
  currentUserLatestBid: any;
  setIsHighestBidder?: any;
}

export default function BidderTagCard({
  latestBid,
  bidsEvent,
  currentUserLatestBid,
  setIsHighestBidder,
}: BidderTagCardProps) {
  const [bidderRank, setBidderRank] = useState(-4);
  const findBidderRankInAuction = () => {
    if (!currentUserLatestBid) {
      return 2;
    } else {
      if (
        latestBid &&
        latestBid?.user_uuid === currentUserLatestBid?.user_uuid
      ) {
        return 1;
      } else {
        return 2;
      }
      // return (
      //   bidsEvent
      //     .sort((a: any, b: any) => {
      //       return b.bid_timestamp - a.bid_timestamp;
      //     })
      //     .findIndex(
      //       (bid: any) => bid?.user_uuid === currentUserLatestBid?.user_uuid
      //     ) + 1
      // );
    }
  };

  useEffect(() => {
    const rank = findBidderRankInAuction();
    setIsHighestBidder && setIsHighestBidder(rank === 1);
    setBidderRank(rank);
  }, [latestBid, bidsEvent?.length, currentUserLatestBid]);
  return (
    <div className="py-1 ">
      {bidderRank === 1 && (
        <div className="bg-linear-green-fade py-2 px-2 sm:px-4 text-xs sm:text-sm flex items-center font-semibold gap-1 sm:gap-4 lg:gap-2 mid:gap-4 text-brand-textBlack relative">
          <SimpleHammerIcon />
          Currently, You are the top Bidder
          <div className="text-brand-orange break-keep text-xs sm:text-sm absolute right-4 sm:right-10 lg:right-0 mid:right-10">
            My Rank: 1
          </div>
        </div>
      )}
      {/* {bidderRank > 1 && bidderRank <= 4 && (
        <div className="bg-linear-green-fade py-2 px-4 text-sm flex items-center font-semibold gap-4 text-brand-textBlack">
          <SimpleHammerIcon />
          You’re not the top bidder
        </div>
      )} */}
      {bidderRank === 2 && (
        <div className="bg-linear-purple py-2 px-4 text-xs sm:text-sm flex items-center font-semibold gap-4 text-brand-textBlack">
          <SimpleHammerIcon />
          Place a higher amount to be a top Bidder
        </div>
      )}
    </div>
  );
}
